import {
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  Router
} from '@angular/router';

import Swal from 'sweetalert2';

import {
  CheckoutService,
  CheckoutData
} from '../../../service/checkout.service';


@Component({
  selector: 'app-checkout-pix',
  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './checkout-pix.component.html',

  styleUrl: './checkout-pix.component.css'
})
export class CheckoutPixComponent implements OnInit {

  dados: CheckoutData | null = null;

  nome = '';

  sobrenome = '';

  cpf = '';

  constructor(
    private checkoutService: CheckoutService,
    private router: Router
  ) {}

  ngOnInit(): void {

    this.dados =
      this.checkoutService.obter();

    if (
      !this.dados ||
      !this.dados.quartoId
    ) {

      Swal.fire({

        icon: 'warning',

        title: 'Checkout expirado',

        text:
          'Os dados da reserva não foram encontrados.',

        confirmButtonText: 'OK',

        confirmButtonColor: '#596238'

      }).then(() => {

        this.router.navigate([
          '/cabana-ype'
        ]);

      });

      return;
    }

    if (
      !this.dados.hospedes ||
      this.dados.hospedes.length === 0
    ) {

      Swal.fire({

        icon: 'warning',

        title: 'Dados dos hóspedes',

        text:
          'Informe os dados dos hóspedes antes de continuar.',

        confirmButtonText: 'OK',

        confirmButtonColor: '#596238'

      }).then(() => {

        this.router.navigate([
          '/checkout/hospedes'
        ]);

      });

      return;
    }

    const hospedePrincipal =
      this.dados.hospedes[0];


    this.nome =
      hospedePrincipal.nome || '';

    this.sobrenome =
      hospedePrincipal.sobrenome || '';

    this.cpf =
      hospedePrincipal.cpf || '';

    this.checkoutService.atualizar({

      formaPagamento: 'PIX'

    });


    this.dados =
      this.checkoutService.obter();

  }

  formatarCpf(): void {

    this.cpf =
      this.cpf
        .replace(/\D/g, '')
        .slice(0, 11);


    if (this.cpf.length > 9) {

      this.cpf =
        this.cpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        );

    }

    else if (this.cpf.length > 6) {

      this.cpf =
        this.cpf.replace(
          /(\d{3})(\d{3})(\d{1,3})/,
          '$1.$2.$3'
        );

    }

    else if (this.cpf.length > 3) {

      this.cpf =
        this.cpf.replace(
          /(\d{3})(\d{1,3})/,
          '$1.$2'
        );

    }

  }

  formatarData(
    data: string | undefined
  ): string {

    if (!data) {

      return '';

    }


    const partes =
      data.split('-');


    if (
      partes.length !== 3
    ) {

      return data;

    }


    return (
      `${partes[2]}/` +
      `${partes[1]}/` +
      `${partes[0]}`
    );

  }

  get descricaoAcomodacao(): string {

    if (this.dados?.quartoId === 1) {

      return 'Cabana confortável em meio à natureza';

    }

    if (this.dados?.quartoId === 2) {

      return 'Um pedaço da Grécia em meio ao Cerrado de Goiás';

    }

    return 'Acomodação no Paraíso do Cerrado';
  }

  continuar(): void {

    if (!this.dados) {

      return;

    }

    if (!this.nome.trim()) {

      this.mostrarAlerta(
        'warning',
        'Nome obrigatório',
        'Informe o nome do titular do PIX.'
      );

      return;

    }

    if (!this.sobrenome.trim()) {

      this.mostrarAlerta(
        'warning',
        'Sobrenome obrigatório',
        'Informe o sobrenome do titular do PIX.'
      );

      return;

    }

    const cpfNumeros =
      this.cpf.replace(/\D/g, '');


    if (cpfNumeros.length !== 11) {

      this.mostrarAlerta(
        'warning',
        'CPF inválido',
        'Informe um CPF válido com 11 dígitos.'
      );

      return;

    }

    if (
      !this.dados.hospedes ||
      this.dados.hospedes.length === 0
    ) {

      this.mostrarAlerta(
        'warning',
        'Dados dos hóspedes',
        'Os dados dos hóspedes não foram encontrados.'
      );

      this.router.navigate([
        '/checkout/hospedes'
      ]);

      return;

    }

    if (!this.dados.reservaId) {

      this.mostrarAlerta(
        'error',
        'Reserva não encontrada',
        'Não foi possível identificar a reserva.'
      );

      return;

    }

    const reservaId = this.dados.reservaId;

    const hospedesAtualizados = [
      ...this.dados.hospedes
    ];


    hospedesAtualizados[0] = {

      ...hospedesAtualizados[0],

      nome:
        this.nome.trim(),

      sobrenome:
        this.sobrenome.trim(),

      cpf:
      cpfNumeros

    };

    this.checkoutService.atualizar({

      hospedes:
      hospedesAtualizados,

      formaPagamento:
        'PIX'

    });


    this.dados =
      this.checkoutService.obter();


    Swal.fire({

      title:
        'Gerando pagamento PIX...',

      text:
        'Aguarde enquanto preparamos seu pagamento.',

      allowOutsideClick:
        false,

      allowEscapeKey:
        false,

      didOpen: () => {

        Swal.showLoading();

      }

    });


    this.checkoutService
      .criarPagamentoPix(
        reservaId
      )
      .subscribe({

        next: (response) => {

          this.checkoutService
            .salvarPagamento(response);

          this.dados =
            this.checkoutService.obter();

          Swal.close();

          this.router.navigate([
            '/checkout/pix/pagamento'
          ]);

        },


        error: (erro) => {

          Swal.close();

          const mensagem =
            erro?.error?.message ||
            erro?.error ||
            'Não foi possível gerar o pagamento PIX.';


          Swal.fire({

            icon: 'error',

            title: 'Erro ao gerar PIX',

            text: mensagem,

            confirmButtonText: 'OK',

            confirmButtonColor: '#596238'

          });

        }

      });

  }

  voltar(): void {

    this.router.navigate([
      '/checkout/pagamento'
    ]);

  }

  get valorTotal(): number {

    return this.dados?.valorTotal || 0;

  }

  get quantidadeHospedes(): number {

    return this.dados?.quantidadeHospedes || 0;

  }

  get hospedes() {

    return this.dados?.hospedes || [];

  }

  get checkIn(): string {

    return this.dados?.checkIn || '';

  }

  get checkOut(): string {

    return this.dados?.checkOut || '';

  }

  get quantidadeNoites(): number {

    return this.dados?.quantidadeNoites || 0;

  }

  get adultos(): number {

    return this.dados?.adultos || 0;

  }

  get criancas(): number {

    return this.dados?.criancas || 0;

  }

  get animais(): number {

    return this.dados?.animais || 0;

  }

  private mostrarAlerta(

    icon:
      'success' |
      'error' |
      'warning' |
      'info' |
      'question',

    title: string,

    text: string

  ): void {

    Swal.fire({

      icon,

      title,

      text,

      confirmButtonText: 'OK',

      confirmButtonColor: '#596238',

      customClass: {

        popup: 'swal-cabana'

      }

    });

  }

}
